import { render, staticRenderFns } from "./ChildInfo.vue?vue&type=template&id=6e8f97ae"
import script from "./ChildInfo.vue?vue&type=script&lang=js"
export * from "./ChildInfo.vue?vue&type=script&lang=js"
import style0 from "./ChildInfo.vue?vue&type=style&index=0&id=6e8f97ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports